export const ModuleEnum = {
  financeiro: 'Financeiro',
  renegociacao: 'Renegociação',
  relatorio: 'Relatório',
  financeiro_remessaBoletos: 'Remessa Boletos',
  financeiro_lancamento: 'Lançamentos',
  financeiro_arrecadacao: 'Arrecadação',
  financeiro_pagamento: 'Pagamentos',
  renegociacao_dividas: 'Dívidas',
  renegociacao_antecipacao: 'Antecipação',
  relatorio_financeiro: 'Financeiro',
  configuracao: 'Configuração',
  configuracao_assinatura: 'Assinatura Digital',
}
